import React from 'react';
import { Button, Col } from 'antd';
import { useSelector } from 'react-redux';
import useRedirect from '../../hooks/navigation/useRedirect';
import { useTranslation } from 'react-i18next';

const PermissionedTabs = ({ tabs }) => {
  const { session, features } = useSelector(state => state.user);
  const permissions = session?.claims;
  const { t } = useTranslation();
  const redirect = useRedirect();
  const hasAccess = tab => {
    const hasPermission =
      permissions?.some(item => item.key === tab.permission && item.value === true) || tab.permission === true;

    const hasFeature = features?.includes(tab.permission);

    return hasPermission || hasFeature;
  };

  return (
    <>
      {tabs.filter(hasAccess).map(tab => (
        <Col key={tab.key}>
          <Button
            onClick={() => redirect(tab.link)}
            className={window.location.pathname.includes(tab.link) ? 'active' : 'inactive'}
            icon={tab.icon || false}
          >
            {t(tab.label)}
          </Button>
        </Col>
      ))}
    </>
  );
};

export default PermissionedTabs;
